import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Shell } from "@/components/Shell";
import { useAuth } from "@/context/AuthContext";
import { api, errMsg } from "@/lib/api";

export default function Register() {
  const { signIn } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ display_name: "", email: "", password: "" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    const name = form.display_name.trim();
    if (name.length < 3 || name.length > 24) return setError("Display name must be 3–24 characters.");
    if (!/^[A-Za-z0-9_][A-Za-z0-9_ ]*[A-Za-z0-9_]$/.test(name)) return setError("Display name can only use letters, numbers, spaces and underscores.");
    if (form.password.length < 6) return setError("Password must be at least 6 characters.");
    setBusy(true); setError("");
    try {
      const { data } = await api.post("/auth/register", { ...form, display_name: name });
      signIn(data);
      nav("/play");
    } catch (err) { setError(errMsg(err)); } finally { setBusy(false); }
  };

  return (
    <Shell hideNav>
      <div className="fade-up">
        <p className="eyebrow">Step 1 of 2</p>
        <h1 className="mt-2 font-display text-3xl font-extrabold tracking-tight">Create your account</h1>
        <p className="mt-2 text-sm text-slate-400">Your display name appears on the leaderboard.</p>
        <form onSubmit={submit} noValidate className="mt-8 space-y-4" data-testid="register-form">
          <label className="block">
            <span className="eyebrow mb-2 block">Display name</span>
            <input className="field" value={form.display_name} onChange={set("display_name")} placeholder="e.g. LogicLion" required minLength={3} maxLength={24} autoComplete="nickname" data-testid="register-display-name-input" />
          </label>
          <label className="block">
            <span className="eyebrow mb-2 block">Email</span>
            <input className="field" type="email" value={form.email} onChange={set("email")} placeholder="you@example.com" required autoComplete="email" data-testid="register-email-input" />
          </label>
          <label className="block">
            <span className="eyebrow mb-2 block">Password</span>
            <input className="field" type="password" value={form.password} onChange={set("password")} placeholder="At least 6 characters" required minLength={6} autoComplete="new-password" data-testid="register-password-input" />
          </label>
          {error && <p className="rounded-xl border border-rose-500/40 bg-rose-500/10 px-4 py-3 text-sm text-rose-300" data-testid="register-error">{error}</p>}
          <button className="btn-primary w-full" disabled={busy} data-testid="register-submit-button">{busy ? "Creating…" : "Create account"}</button>
        </form>
        <p className="mt-6 text-center text-sm text-slate-400">Already registered? <Link to="/login" className="font-semibold text-white underline-offset-4 hover:underline" data-testid="register-login-link">Log in</Link></p>
      </div>
    </Shell>
  );
}
